import * as service from "../service";
import { store } from "../../store";

export type SocietyInfo = {
  id: string;
  name: string;
  icon: string | null;
  description: string | null;
  university: string | null;
  instagram_url: string | null;
  chop_image_url: string | null;
  memberCount: number;
  pendingCount: number;
  ctime: string | null;
  utime: string | null;
};

export type GetAllSocietiesParams = {
  q?: string;
  page?: number;
  size?: number;
};

export type GetAllSocietiesResponse = {
  data: SocietyInfo[];
  total: number;
  page: number;
  size: number;
  hasMore: boolean;
};

/**
 * Fetch paginated societies (admin only).
 * Backend: GET /api/society/getAllSocieties
 */
export const GetAllSocietiesAPI = async (
  params?: GetAllSocietiesParams,
): Promise<any> => {
  try {
    const admin = store.getState().auth.admin;
    const resp = await service.call(
      "GET",
      "/api/society/getAllSocieties",
      {
        user_id: admin.id,
        ...(params?.q ? { q: params.q } : {}),
        ...(params?.page ? { page: params.page } : {}),
        ...(params?.size ? { size: params.size } : {}),
      },
    );
    return resp;
  } catch (err) {
    console.error(`GetAllSocietiesAPI ${err}`);
    return { status: -1, resp: err };
  }
};